export default __webpack_public_path__ + "static/media/device-mobile-1.d157d6b9.png";